
import '../../scss/game-description.scss'

interface GameDescription{
    isMobile:boolean;
}

const GameDescription = (props:GameDescription)=>{

    return (
        <div className={props.isMobile ?  "game-description" : "game-description-desktop"}>
            <h2>Bitcoin 1-minute game</h2>
            <p>Every minute, the price is locked and a new round starts.</p>
        </div>
    )
}

export default GameDescription;
